import { FlexBox } from '@brg/ui';
import { LayoutConst } from 'core';
import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import styled, { keyframes, css } from 'styled-components';

enum AnimationType {
    wide = 'wide',
    narrow = 'narrow',
}

export const SlideAnim = keyframes`
  from {
    width: 46px;
    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        width: 36px;
    }
  }
  to {
    width: 124px;
  }
`;

export const RevertSlideAnim = keyframes`
  from {
    width: 124px;
  }
  to {
    width: 46px;
    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        width: 36px;
    }
  }
`;

export const PointWrapper = styled(FlexBox)`
    position: absolute;
    top: 10px;
    right: 16px;
    place-items: end;
    justify-content: flex-end;
    width: 124px;
    display: flex;
    z-index: 1;
`;

export const TextPoint = styled.span<{ textVisible?: boolean | null, animation?: AnimationType | boolean }>`
    color: #fff;
    display: flex;
    flex-flow: row;
    justify-content: center;
    font-family: 'Inter';
    font-size: ${({ textVisible }) => textVisible ? '11px' : '17px'};
    font-weight: 700;
    line-height: ${({ textVisible }) => textVisible ? '13px' : '22px'};
    background: #146DEE;
    backdrop-filter: blur(2px);
    -webkit-backdrop-filter: blur(2px);
    white-space: nowrap;
    border-radius: 4px;
    padding: 4px 12px;
    width: ${({ textVisible }) => textVisible ? '124px' : '46px'};
    height: 32px;
    text-align: center;

    div {
        margin-right: 8px;
    }

    ${({animation}) => animation === AnimationType.wide ? css`
    animation: ${SlideAnim} 0.2s ease-in-out;
    animation-fill-mode: forwards;
  ` : animation === AnimationType.narrow ? css`
    animation: ${RevertSlideAnim} 0.2s ease-in-out;
    animation-fill-mode: forwards;
  ` : null};



    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: ${({ textVisible }) => textVisible ? '11px' : '13px'};
        line-height: ${({ textVisible }) => textVisible ? '13px' : '16px'};
        width: ${({ textVisible }) => textVisible ? '124px' : '36px'};
        padding: ${({ textVisible }) => textVisible ? '5.5px 8px' : '4px 8px'};
        height: 24px;
    }
`;
export const PointBox: FC<{ points?: number, textVisible?: boolean }> = ({ points, textVisible = null }) => {
    const { t } = useTranslation();

    const animSlide = useMemo(() => textVisible !== null &&  (textVisible ? AnimationType.wide : AnimationType.narrow)  , [textVisible])

    if (!points) {
        return null;
    }

    return (
        <PointWrapper>
            <TextPoint textVisible={textVisible} animation={animSlide}>
                {textVisible ? <div>{t('competition_edit.middle_point')}</div> : ''}
                {points}
            </TextPoint>
        </PointWrapper>
    )
}import { FlexBox } from '@brg/ui';
import { LayoutConst } from 'core';
import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import styled, { keyframes, css } from 'styled-components';

enum AnimationType {
    wide = 'wide',
    narrow = 'narrow',
}

export const SlideAnim = keyframes`
  from {
    width: 46px;
    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        width: 36px;
    }
  }
  to {
    width: 124px;
  }
`;

export const RevertSlideAnim = keyframes`
  from {
    width: 124px;
  }
  to {
    width: 46px;
    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        width: 36px;
    }
  }
`;

export const PointWrapper = styled(FlexBox)`
    position: absolute;
    top: 10px;
    right: 16px;
    place-items: end;
    justify-content: flex-end;
    width: 124px;
    display: flex;
    z-index: 1;
`;

export const TextPoint = styled.span<{ textVisible?: boolean | null, animation?: AnimationType | boolean }>`
    color: #fff;
    display: flex;
    flex-flow: row;
    justify-content: center;
    font-family: 'Inter';
    font-size: ${({ textVisible }) => textVisible ? '11px' : '17px'};
    font-weight: 700;
    line-height: ${({ textVisible }) => textVisible ? '13px' : '22px'};
    background: #146DEE;
    backdrop-filter: blur(2px);
    -webkit-backdrop-filter: blur(2px);
    white-space: nowrap;
    border-radius: 4px;
    padding: 4px 12px;
    width: ${({ textVisible }) => textVisible ? '124px' : '46px'};
    height: 32px;
    text-align: center;

    div {
        margin-right: 8px;
    }

    ${({animation}) => animation === AnimationType.wide ? css`
    animation: ${SlideAnim} 0.2s ease-in-out;
    animation-fill-mode: forwards;
  ` : animation === AnimationType.narrow ? css`
    animation: ${RevertSlideAnim} 0.2s ease-in-out;
    animation-fill-mode: forwards;
  ` : null};



    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: ${({ textVisible }) => textVisible ? '11px' : '13px'};
        line-height: ${({ textVisible }) => textVisible ? '13px' : '16px'};
        width: ${({ textVisible }) => textVisible ? '124px' : '36px'};
        padding: ${({ textVisible }) => textVisible ? '5.5px 8px' : '4px 8px'};
        height: 24px;
    }
`;
export const PointBox: FC<{ points?: number, textVisible?: boolean }> = ({ points, textVisible = null }) => {
    const { t } = useTranslation();

    const animSlide = useMemo(() => textVisible !== null &&  (textVisible ? AnimationType.wide : AnimationType.narrow)  , [textVisible])

    if (!points) {
        return null;
    }

    return (
        <PointWrapper>
            <TextPoint textVisible={textVisible} animation={animSlide}>
                {textVisible ? <div>{t('competition_edit.middle_point')}</div> : ''}
                {points}
            </TextPoint>
        </PointWrapper>
    )
}